"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TabsTable = void 0;

var _emotion = require("emotion");

var _react = _interopRequireDefault(require("react"));

var _recompose = require("recompose");

var _CustomPagination = _interopRequireDefault(require("./DataTable/Table/CustomPagination"));

var _reactTable = _interopRequireDefault(require("react-table"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var enhance = (0, _recompose.compose)((0, _recompose.withState)('activeTab', 'setActiveTab', null), (0, _recompose.withPropsOnChange)(['tabs'], function (_ref) {
  var tabs = _ref.tabs,
      activeTab = _ref.activeTab,
      setActiveTab = _ref.setActiveTab;
  var tabsWithKey = tabs.map(function (x) {
    return _objectSpread(_objectSpread({}, x), {}, {
      key: x.key || x.title
    });
  });
  !activeTab && (tabs === null || tabs === void 0 ? void 0 : tabs.length) && setActiveTab(tabsWithKey[0].key);
  return {
    tabs: tabsWithKey
  };
}));

var TabsTable = function TabsTable(_ref2) {
  var className = _ref2.className,
      columns = _ref2.columns,
      data = _ref2.data,
      _ref2$pageSize = _ref2.pageSize,
      pageSize = _ref2$pageSize === void 0 ? 10 : _ref2$pageSize,
      props = _objectWithoutProperties(_ref2, ["className", "columns", "data", "pageSize"]);

  return /*#__PURE__*/_react["default"].createElement(_reactTable["default"], _objectSpread({
    columns: columns,
    data: data,
    className: "tabs-table ".concat(className, " -striped"),
    minRows: 0,
    sortable: false,
    resizable: false,
    pageSize: pageSize,
    showPagination: (data === null || data === void 0 ? void 0 : data.length) > pageSize,
    PaginationComponent: function PaginationComponent(props) {
      return /*#__PURE__*/_react["default"].createElement(_CustomPagination["default"], _extends({}, props, {
        showPageSizeOptions: false,
        paginationStyle: {
          justifyContent: 'center'
        }
      }));
    }
  }, props));
};

exports.TabsTable = TabsTable;

var Tabs = function Tabs(_ref3) {
  var _tabs$find;

  var tabs = _ref3.tabs,
      activeTab = _ref3.activeTab,
      setActiveTab = _ref3.setActiveTab;
  return (tabs === null || tabs === void 0 ? void 0 : tabs.length) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "tabs"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _emotion.merge)( /*#__PURE__*/(0, _emotion.css)("display:flex;") + (" " + "tabs-titles"))
  }, tabs.map(function (_ref4) {
    var key = _ref4.key,
        title = _ref4.title;
    return /*#__PURE__*/_react["default"].createElement("div", {
      key: key,
      className: "tabs-title ".concat(key === activeTab ? "active-tab" : ""),
      onClick: function onClick() {
        return setActiveTab(key);
      }
    }, title);
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "tabs-content"
  }, (_tabs$find = tabs.find(function (t) {
    return t.key === activeTab;
  })) === null || _tabs$find === void 0 ? void 0 : _tabs$find.content));
};

var _default = enhance(Tabs);

exports["default"] = _default;